'use client'
import { useGiphyFetch } from '@/app/util/use-gf'
import Grid from '@/components/grid/grid'
import { IGif } from '@giphy/js-types'

const getTrackingUrl = (page: number) => `/trending-gifs/page/${page}`

type Props = { initialGifs: IGif[] }
const TrendingGrid = (props: Props) => {
    const gf = useGiphyFetch()
    return (
        <Grid
            initialGifs={props.initialGifs}
            fetchGifs={async (offset: number) =>
                gf.trending({
                    offset,
                    limit: 15,
                })
            }
            gaTrackingUrl={getTrackingUrl}
        />
    )
}

export default TrendingGrid
